import React, { Fragment,useEffect } from 'react'
import CSS from './LandingPage.module.css';
import {Button} from 'semantic-ui-react';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import {withRouter} from 'react-router';
import { useTheme,useMediaQuery } from '@material-ui/core';


function LandingPage(props) {

    const theme = useTheme()
    const isMatch = useMediaQuery(theme.breakpoints.up("sm"))

    useEffect(() => {
        window.scrollTo(0,0)
    })

    const gotoExplore=()=>{
        props.history.push('/services')
    }

    return (
     <Fragment>
     <div className={CSS.back}>
         <div className={CSS.overlay}>
         <div className={CSS.content}>
             <h1 className="display-6">We are Vendorweb, powered by Cocentric Industrial Solutions</h1>
             <p>A B2B , online and offline marketplace connecting buyers and sellers amongst manufacturing industries offering variety of services to the customers in a single vendorcode.</p>
             {
                 !isMatch ? 
                <Button onClick={gotoExplore} size="small" className="mt-4" color="grey">Explore our services</Button>
                    :
                <Button onClick={gotoExplore} size="small" className="mt-2" color="linkedin">Explore our services</Button>
                }
         </div>
         </div>
         
     </div>
     <Section1 />
     <Section2 />
     <Section3 />
     <Section4 />
     
     </Fragment>
    )
}

export default withRouter(LandingPage)
